import React, { useState, useEffect } from 'react';
import { PlusCircle, Trash2 } from 'lucide-react';
import axios from 'axios';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { getUsername, getInitials } from "../../utils/common_functions";
import { API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import { useNavigate} from "react-router-dom";
import Select from 'react-select';

const complianceOptions = [
  { value: 'GxP', label: 'GxP' },
  { value: 'HIPAA', label: 'HIPAA' },
  { value: 'GDPR', label: 'GDPR' },
  { value: 'SOC2', label: 'SOC2' },
  { value: 'ISO27001', label: 'ISO27001' },
];


const regionOptions = [
  { value: 'Africa', label: 'Africa' },
  { value: 'Asia Pacific', label: 'Asia Pacific' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Canada', label: 'Canada' },
  { value: 'China', label: 'China' },
  { value: 'Europe', label: 'Europe' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Middle East', label: 'Middle East' },
  { value: 'US East', label: 'US East' },
  { value: 'US West', label: 'US West' },
];



const JsonFormBuilder = ({documentid,documentname,cloudService,backtolist,editJson=""}) => {

let serviceOptionsList = [];

Object.entries(cloudService).forEach(([provider, services]) => {
    const mappedServices = services.map(service => ({
      label: service,
      value: service,
      provider: provider
    }));
  
    serviceOptionsList = serviceOptionsList.concat(mappedServices);
  });



  let initialForm;

  if(documentid!=="" && editJson===""){
    initialForm = {
      projectName: documentname,
      templateName:'',
      documentMeta: {
        version: '',
        author: '',
        date: ''
      },
      cloud: '',
      deploymentArchitecture: '',
      compliance: [],
      defaultEnvironment: '',
      regionPreference: [],
      cloudService:[],
      dataClassification: '',
      retentionDays: '',
      autoScalingRequired: '',
      budgetTier: '',
      architectureSummary: '',
      assumptions: [''],
      outOfScope: [''],
      feedback: [''],
      // requirements: [
      //   { requirementId: '', description: '', type: 'Security', comment: '' }
      // ]
    };
    
  }
  else if(editJson!==""){




    initialForm = {
      projectName: editJson.projectName,
      templateName:editJson.templateName,
      cloudService:editJson.serviceOptions,
      documentMeta: {
        version: '',
        author: '',
        date: ''
      },
      cloud: editJson.cloud,
      deploymentArchitecture: editJson.deploymentArchitecture,
      compliance: editJson.compliance,
      defaultEnvironment: editJson.defaultEnvironment,
      regionPreference: editJson.region,
      dataClassification: editJson.dataClassification,
      retentionDays: editJson.retentionDays,
      autoScalingRequired: editJson.autoScalingRequired,
      budgetTier: editJson.budgetTier,
      architectureSummary: editJson.architectureSummary,
      assumptions: editJson.assumptions,
      outOfScope: editJson.outOfScope,
      feedback: editJson.feedback,
      // requirements: [
      //   { requirementId: '', description: '', type: 'Security', comment: '' }
      // ]
    }

//    initialForm = editJson;
  //  initialForm.version = 
  }
  else {
    initialForm = {
      projectName: '',
      templateName:'',
      documentMeta: {
        version: '',
        author: '',
        date: ''
      },
      cloud: '',
      deploymentArchitecture: '',
      compliance: [],
      defaultEnvironment: '',
      regionPreference: [],
      cloudService:[],
      dataClassification: '',
      retentionDays: '',
      autoScalingRequired: '',
      budgetTier: '',
      architectureSummary: '',
      assumptions: [''],
      outOfScope: [''],
      feedback: [''],
      requirements: [
        { requirementId: '', description: '', type: 'Security', comment: '' }
      ]
    };

  }

  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();


  const [selectedService, setSelectedService] = useState(null);
  const [selectedCloud, setSelectedCloud] = useState(null);


  const validate = () => {
    const newErrors = {};

   
if(formData.requirements !== undefined && formData.requirements.length > 0){
    formData.requirements.forEach((req, i) => {
        if (!req.requirementId.trim() || !req.description.trim()) {
          newErrors[`requirement-${i}`] = 'Requirement ID and Description are required';

          if (!(formData.projectName || "").trim()) {
            newErrors.projectName = "Project name is required";
          }

        }
      });
    }




    if (!(formData.templateName || "").trim()) {
      newErrors.templateName = "Infrastructure Context Name is required";
    }
    
    
//    if (!formData.projectName.trim()) newErrors.projectName = 'Project name is required';
    // if (!formData.documentMeta.version.trim()) newErrors.version = 'Version is required';
    // if (!formData.documentMeta.author.trim()) newErrors.author = 'Author is required';
    // if (!formData.documentMeta.date.trim()) newErrors.date = 'Date is required';
   if (!formData.cloud.trim()) newErrors.cloud = 'Cloud Provider is required';

   // if(documentid===undefined){
      // formData.requirements.forEach((req, i) => {
      //   if (!req.requirementId.trim() || !req.description.trim()) {
      //     newErrors[`requirement-${i}`] = 'Requirement ID and Description are required';
      //   }
      // });
    //}

    return newErrors;
  };

  useEffect(() => {
    const validationErrors = validate();
    setErrors(validationErrors);
    setIsFormValid(Object.keys(validationErrors).length === 0);
  }, [formData]);

  const handleChange = (path, value) => {
    const keys = path.split('.');
    const newData = { ...formData };
    let ref = newData;
    keys.slice(0, -1).forEach(k => ref = ref[k]);
    ref[keys[keys.length - 1]] = value;
    setFormData(newData);
  };

  const handleArrayChange = (field, index, value) => {
    const updated = [...formData[field]];
    updated[index] = value;
    setFormData({ ...formData, [field]: updated });
  };

  const addToArray = field => {
    setFormData({ ...formData, [field]: [...formData[field], ''] });
  };

  const removeFromArray = (field, index) => {
    const updated = formData[field].filter((_, i) => i !== index);
    setFormData({ ...formData, [field]: updated });
   
  };

  const handleRequirementChange = (index, field, value) => {
    const updated = [...formData.requirements];
    updated[index][field] = value;
    setFormData({ ...formData, requirements: updated });
  };

  const addRequirement = () => {

    if (!('requirements' in formData)) {
      formData.requirements  = [
        ]
    }  
    setFormData({
      ...formData,
      requirements: [...formData.requirements, {
        requirementId: '',
        description: '',
        type: 'Technical',
        comment: ''
      }]
    });
  };

  const removeRequirement = (index) => {
    const updated = formData.requirements.filter((_, i) => i !== index);


    if(formData.requirements.length ===0){
      delete formData.requirements;
      setFormData(formData)
    } else {
      setFormData({ ...formData, requirements: updated });
    }
  };

  const clearForm = () => {
    setFormData(initialForm);
    setErrors({});
  };

  const saveForm = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        const token = JSON.parse(localStorage.getItem("jsondata") || "{}").accessToken || "";

        // alert(documentid)
        // console.log(formData)

        if(editJson!==""){


          formData.projectName = formData.projectName==="" ? "Testing" : formData.projectName 
          
          
          let postData = {
            "templateName": formData.templateName,
            "cloud": formData.cloud,
            "deploymentArchitecture": formData.templateName,
            "compliance": formData.compliance,
            "defaultEnvironment": formData.defaultEnvironment,
            "region":formData.regionPreference,
            "dataClassification": formData.dataClassification,
            "retentionDays": formData.retentionDays,
            "autoScalingRequired": formData.autoScalingRequired,
            "budgetTier": formData.budgetTier,
            "contextSummary": formData.contextSummary,
            "assumptions":formData.assumptions,
            "serviceOptions":formData.cloudService
        }

          
          const response = await axios.post(`${API_SERVER_URL}templates/`+editJson._id+`/update/`, postData, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
            backtolist()
      //      window.location.reload();
          }
          return;
        }
        if(documentid!==undefined){
          const response = await axios.post(`${API_SERVER_URL}template/`+documentid+`/additional-info/`, formData, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
            navigate("/tech-spec/")
          }
        }else{

    //          formData.projectName = "Testing"
          formData.projectName = formData.projectName==="" ? "Testing" : formData.projectName
          
          

          let postData = {
            "templateName": formData.templateName,
            "cloud": formData.cloud,
            "deploymentArchitecture": formData.templateName,
            "compliance": formData.compliance,
            "defaultEnvironment": formData.defaultEnvironment,
            "region":formData.regionPreference,
            "dataClassification": formData.dataClassification,
            "retentionDays": formData.retentionDays,
            "autoScalingRequired": formData.autoScalingRequired,
            "budgetTier": formData.budgetTier,
            "contextSummary": formData.contextSummary,
            "assumptions":formData.assumptions,
            "serviceOptions":formData.cloudService
        }

          const response = await axios.post(`${API_SERVER_URL}templates/`, postData, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
            //navigate("/infrastructure-context/list")
          //  window.location.reload();
          backtolist()

          }
        }
        
        

      } catch (error) {
        console.error("Submission failed:", error);
      }
    }
  };

  const renderError = key =>
    errors[key] && <div style={{ color: 'red', fontSize: '0.85rem' }}>{errors[key]}</div>;

  const inputStyle = {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    width: '100%'
  };

  return (
    <div style={{ padding: '1rem' }}>
      <form>
        <h1 className="text-xl font-semibold mb-[8px]">1.General Information</h1>



        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          

          
          <div style={{ flex: '1 1 30%' }}>
            <input placeholder="Infrastructure Context Name" 
            
 value={formData.templateName} onChange={e => handleChange('templateName', e.target.value)} style={inputStyle} />
            {renderError('templateName')}
          </div>

          <div style={{ flex: '1 1 30%' }} className='d-none'>
            <input placeholder="Version" value={formData.documentMeta.version} onChange={e => handleChange('documentMeta.version', e.target.value)} style={inputStyle} />
            {renderError('version')}
          </div>

          <div style={{ flex: '1 1 30%' }} className='d-none'>
            <input placeholder="Author" value={formData.documentMeta.author} onChange={e => handleChange('documentMeta.author', e.target.value)} style={inputStyle} />
            {renderError('author')}
          </div>

          <div style={{ flex: '1 1 30%' }} className='d-none'>
            <input type="date" value={formData.documentMeta.date} onChange={e => handleChange('documentMeta.date', e.target.value)} style={inputStyle} />
            {renderError('date')}
          </div>

          <div style={{ flex: '1 1 30%' }}>
            &nbsp;
          </div>
          
          <div style={{ flex: '1 1 30%' }}>
            &nbsp;
          </div>
          </div>
      
          <br/>
          <h1 className="text-xl font-semibold mb-[5px]">2.Cloud & Policy Settings</h1>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>

          <div style={{ flex: '1 1 30%' }}>
            <select value={formData.cloud} onChange={e => handleChange('cloud', e.target.value)} style={inputStyle}>
              <option value="">Cloud Provider</option>
              <option value="AWS">AWS</option>
              <option value="Azure">Azure</option>
              <option value="GCP">GCP</option>
            </select>
            {renderError('cloud')}
          </div>


<Select
  isMulti
  options={
    formData.cloud
      ? serviceOptionsList.filter(
          (option) =>
            option.provider.toLowerCase() === formData.cloud.toLowerCase()
        )
      : []
  }
  placeholder="Cloud Service"
  value={
    formData.cloud
      ? serviceOptionsList.filter(
          (option) =>
            option.provider.toLowerCase() === formData.cloud.toLowerCase() &&
            (formData.cloudService || []).includes(option.value)
        )
      : []
  }
  onChange={(selected) =>
    handleChange('cloudService', selected.map((s) => s.value))
  }
  styles={{ container: (base) => ({ ...base, flex: '1 1 30%' }) }}
/>



          <div style={{ flex: '1 1 30%' }}>
            <select value={formData.deploymentArchitecture} onChange={e => handleChange('deploymentArchitecture', e.target.value)} style={inputStyle}>
              <option value="">Deployment</option>
              <option value="Serverless">Serverless</option>
              <option value="Containerized">Containerized</option>
              <option value="Hybrid">Hybrid</option>
            </select>
          </div>

          {/* <div style={{ flex: '1 1 30%' }}>
            <select value={formData.compliance} onChange={e => handleChange('compliance', e.target.value)} style={inputStyle}>
              <option value="">Compliance</option>
              <option value="GxP">GxP</option>
              <option value="HIPAA">HIPAA</option>
              <option value="GDPR">GDPR</option>
            </select>
          </div> */}

<div style={{ flex: '1 1 30%' }}>
  <Select
  isMulti
  options={complianceOptions}
  placeholder="Compliance"
  value={complianceOptions.filter((opt) =>
    formData.compliance.includes(opt.value)
  )}
  onChange={(selected) =>
    handleChange('compliance', selected.map((s) => s.value))
  }
  styles={{ container: (base) => ({ ...base, flex: '1 1 30%' }) }}
/>
</div>



          <div style={{ flex: '1 1 30%' }}>
            <select value={formData.defaultEnvironment} onChange={e => handleChange('defaultEnvironment', e.target.value)} style={inputStyle}>
              <option value="">Environment</option>
              <option value="DEV">DEV</option>
              <option value="QA">QA</option>
              <option value="PROD">PROD</option>
              <option value="ALL">ALL</option>
            </select>
          </div>

          {/* <div style={{ flex: '1 1 30%' }}>
            <select value={formData.regionPreference} onChange={e => handleChange('regionPreference', e.target.value)} style={inputStyle}>
              <option value="">Region</option>
              <option value="Africa">Africa</option>
              <option value="Asia Pacific">Asia Pacific</option>
              <option value="Australia">Australia</option>
              <option value="Canada">Canada</option>
              <option value="China">China</option>
              <option value="Europe">Europe</option>
              <option value="Israel">Israel</option>
              <option value="Mexico">Mexico</option>
              <option value="Middle East">Middle East</option>
              <option value="South America">South America</option>
              <option value="US East">US East</option>
              <option value="US West">US West</option>
            </select>
          </div> */}




<div style={{ flex: '1 1 30%' }}>
  <Select
  isMulti
  options={regionOptions}
  placeholder="Region"
  value={regionOptions.filter((opt) =>
    formData.regionPreference.includes(opt.value)
  )}
  onChange={(selected) =>
    handleChange('regionPreference', selected.map((s) => s.value))
  }
  styles={{ container: (base) => ({ ...base, flex: '1 1 30%' }) }}
/>
</div>



          <div style={{ flex: '1 1 30%' }}>
            <select value={formData.dataClassification} onChange={e => handleChange('dataClassification', e.target.value)} style={inputStyle}>
              <option value="">Data Classification</option>
              <option value="Public">Public</option>
              <option value="Internal">Internal</option>
              <option value="Confidential">Confidential</option>
              <option value="Regulated">Regulated</option>
            </select>
          </div>

          <div style={{ flex: '1 1 30%' }}>
            <input type="number" placeholder="Retention Days" value={formData.retentionDays} onChange={e => handleChange('retentionDays', e.target.value)} style={inputStyle} />
          </div>

          <div style={{ flex: '1 1 30%' }}>
            <select value={formData.autoScalingRequired} onChange={e => handleChange('autoScalingRequired', e.target.value)} style={inputStyle}>
              <option value="">Auto Scaling Required?</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </div>

          <div style={{ flex: '1 1 30%' }}>
            <select value={formData.budgetTier} onChange={e => handleChange('budgetTier', e.target.value)} style={inputStyle}>
              <option value="">Budget Tier</option>
              <option value="Cost-Optimized">Cost-Optimized</option>
              <option value="Performance">Performance</option>
            </select>
          </div>

          </div>

          <br/>
          <h1 className="text-xl font-semibold mb-[5px]">3.Additional Infrastructure Context</h1>


          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>

          <div style={{ flex: '1 1 100%' }}>
            <textarea placeholder="Architecture Summary" value={formData.architectureSummary} onChange={e => handleChange('architectureSummary', e.target.value)} style={{ ...inputStyle, height: '80px' }} />
          </div>
        </div>

        {/* Additional Form Fields Continue... */}

                {/* Array Fields */}
                {["assumptions", "outOfScope", "feedback"].map(field => (
              field=== "assumptions" ? 
          <div key={field} style={{ marginTop: '1rem' }} className='d-none'>
            <h3>
            {field=== "outOfScope" ? 
                  "Out Of Scope"
            :

             field=== "assumptions" ? 
                  "Design Assumption" :

              field.charAt(0).toUpperCase() + field.slice(1)}</h3>
            {formData[field].map((val, i) => (
              <div key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: 5 }}>
                <input value={val} onChange={e => handleArrayChange(field, i, e.target.value)} style={{ ...inputStyle, flex: 1 }} />
                {i !== 0 && (
                  <button type="button" onClick={() => removeFromArray(field, i)} style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}>
                    <Trash2 size={18} />
                  </button>
                )}
              </div>
            ))}
            {renderError(field)}
            <button type="button" onClick={() => addToArray(field)} style={{ display: 'flex', alignItems: 'center', gap: '4px', background: 'none', border: 'none', color: 'blue', cursor: 'pointer' }}>
              <PlusCircle size={18} />
              Add
            </button>
          </div> :""
        ))}

        {/* Requirements Section */}
      
        
        <br/>

        {documentid === undefined && formData.requirements!==undefined && formData.requirements.length > 0 && (<>
          <h1 className="text-xl font-semibold mb-[5px]">4.Requirements</h1>
        <div style={{ flex: '1 1 30%' }}>
            <input placeholder="Project Name" 
 value={formData.projectName} onChange={e => handleChange('projectName', e.target.value)} style={inputStyle} />
            {renderError('projectName')}
          </div><br/></>)}

        {documentid === undefined && formData.requirements!==undefined && (
        formData.requirements.map((req, i) => (
  <div key={i} style={{ border: '1px solid #ccc', padding: 10, borderRadius: '6px', marginBottom: '1rem' }}>
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <input
        placeholder="Requirement ID"
        value={req.requirementId}
        onChange={e => handleRequirementChange(i, 'requirementId', e.target.value)}
        style={{ ...inputStyle, flex: 1 }}
      />
      {i >= 0 && (
        <button
          type="button"
          onClick={() => removeRequirement(i)}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
        >
          <Trash2 size={18} />
        </button>
      )}
    </div>

    <textarea
      placeholder="Description"
      value={req.description}
      onChange={e => handleRequirementChange(i, 'description', e.target.value)}
      style={{ ...inputStyle, height: '60px' }}
    />

    {renderError(`requirement-${i}`)}

    <select
      value={req.type}
      onChange={e => handleRequirementChange(i, 'type', e.target.value)}
      style={inputStyle}
    >
      <option value="Functional">Functional</option>
      <option value="Security">Security</option>
      <option value="Service Role">Service Role</option>
      <option value="Technical">Technical</option>
    </select>

    <input
      placeholder="Comment (optional)"
      value={req.comment}
      onChange={e => handleRequirementChange(i, 'comment', e.target.value)}
      style={inputStyle}
    />
  </div>
)))}


        {/* {documentid === undefined  && (
        <button type="button" onClick={addRequirement} style={{ display: 'flex', alignItems: 'center', gap: '4px', background: 'none', border: 'none', color: 'blue', cursor: 'pointer', marginBottom: '1rem' }}>
          <PlusCircle size={18} />
          Add Requirement
        </button>)} */}

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
          <button
            type="button"
            disabled={!isFormValid}
            onClick={saveForm}
            className={`px-4 py-2 rounded transition-colors ${isFormValid ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-400 text-white cursor-not-allowed'}`}
          >
            Save
          </button>
          <button type="button" onClick={clearForm} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            Clear
          </button>
        </div>
        
      </form>
    </div>
  );
};

export default JsonFormBuilder;
